import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import CSOBGuide from "./Guide";

import CardGuide from "@components/common/CardGuide/CardGuide";

interface GuideContainer {}

const GuideContainer: FC<GuideContainer> = () => {
  const { t } = useTranslation();

  const steps: CardGuide["steps"] = [
    {
      title: `${t("common.step")} 1`,
      description: t("common.fillInData"),
      detail: {
        title: t("csob.supplier.guidenceTitle"),
        points: [
          t("csob.supplier.hub.point.fillInSharedForm"),
          t("csob.supplier.hub.point.enterDataRequiredYear"),
          t("csob.supplier.hub.point.mandatoryFieldsCorrectlyFilled"),
        ],
      },
    },
    {
      title: `${t("common.step")} 2`,
      description: t("csob.supplier.hub.shareDataWithBuyer"),
      detail: {
        title: t("csob.supplier.guidenceTitle"),
        points: [
          t("csob.supplier.hub.point.clickSubmitButton"),
          t("csob.supplier.hub.point.waitForConfirmation"),
        ],
      },
    },
    // { TODO: hidden for now
    //   title: `${t("common.step")} 3`,
    //   description: t("csob.supplier.hub.analyzeResults"),
    //   detail: {
    //     title: t("csob.supplier.guidenceTitle"),
    //     points: [
    //       t("csob.supplier.hub.point.resultsInSectionReports"),
    //       t("csob.supplier.hub.point.applyRelevantFilters"),
    //     ],
    //   },
    // },
  ];

  return <CSOBGuide steps={steps} />;
};

export default GuideContainer;
